// plantillasAMedida.js — ESPEJO del cuerpo de aws_lambdas/_shared_autoescuela/plantillasAMedida.js (plantillas de
// WhatsApp a medida de una autoescuela). NO editar entre las marcas: se edita el canónico y
// `node aws_lambdas/_shared_autoescuela/plantillasCopias.js`. Ficha: docs/features/autoescuela-plantillas-por-empresa.md

// ── plantillasAMedida: cuerpo compartido (inicio) ──
/**
 * Registro de plantillas a medida. Clave = NOMBRE EN META (crearla con
 * `node admin_scripts/autoescuela_plantillas_a_medida.js crear <nombre>`, esperar APPROVED/UTILITY con `estado`).
 *
 *   "<nombre>": {
 *     base: "<plantilla _trial estándar a la que sustituye>",   // p. ej. "practica_recordatorio_crm_trial"
 *     para: "<company_id> · <quién lo pidió y cuándo>",          // informativo
 *     es: { header?, body, footer?, botones?, cta? },             // textos; lo que falte se hereda de la base
 *     ca?: { ... },                                               // traducción `ca` con el MISMO nombre (opcional)
 *   }
 *
 * Reglas (las comprueba el test contra la base): el cuerpo usa las MISMAS variables {{1}}..{{n}} que la base, los
 * botones son los mismos (mismo número y orden, sin emojis), y para la prueba gratuita el texto tiene que salir
 * UTILITY (docs/guides/meta-templates-utility.md). `header`/`footer` ausentes = los de la base; "" = sin ellos.
 * Sin «¿»/«¡» de apertura en lo que escribimos nosotros (memoria feedback_mensajes_sin_signos_apertura).
 */
const PLANTILLAS_A_MEDIDA = Object.freeze({
  // ── CITAS (no solo autoescuelas): el mapa de la empresa vive en c_company_configs.settings.plantillas_a_medida y la
  //    plantilla se crea en la WABA del número de su sector (admin_scripts/citas_plantillas_a_medida.js). ──
  // Terapeuta Harold (9/10/2026): la confirmación dice dónde es y que hay parking y aseo gratis. Número «Citas ConextCRM».
  cita_confirmada_harold_trial: {
    base: "cita_confirmada_crm_trial_v3",
    para: "terapeuta-harold-c76b79 · David 9/10/2026 (parking y aseo gratuitos)",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n💆 *Servicio:* {{5}}\n📍 *Lugar:* Centro Comercial Family Cash, Lorca\n🅿️ Parking y aseo gratuitos.\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos." },
  },
  cita_confirmada_harold_1_trial: {
    base: "cita_confirmada_crm_1_trial",
    para: "terapeuta-harold-c76b79 · primera cita del cliente",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n💆 *Servicio:* {{5}}\n📍 *Lugar:* Centro Comercial Family Cash, Lorca\n🅿️ Parking y aseo gratuitos.\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos.\n\n📲 *Para tus próximas citas, escríbenos directamente a este número.*" },
  },
  cita_confirmada_harold_ficha_trial: {
    base: "cita_confirmada_crm_ficha_trial_v2",
    para: "terapeuta-harold-c76b79 · cliente con 2+ citas futuras (botón «Ver mi ficha»)",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n💆 *Servicio:* {{5}}\n📍 *Lugar:* Centro Comercial Family Cash, Lorca\n🅿️ Parking y aseo gratuitos.\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos." },
  },
  // Beuty&nails Viviana Herrera (15/10/2026, David): la dirección del negocio al final de la confirmación. Número de
  // peluquerías (+1 903 865 3085, WABA 1732334534475626). Las tres variantes, como Harold.
  cita_confirmada_viviana_trial: {
    base: "cita_confirmada_crm_trial_v3",
    para: "beuty-nails-viviana-herrera-be-6ac16a · David 15/10/2026 (dirección al final)",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n✂️ *Servicio:* {{5}}\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos.\n\n📍 *Dirección:* Plaza Generalife 4, local 7 (barrio Santa Aurelia), 41006 Sevilla" },
  },
  cita_confirmada_viviana_1_trial: {
    base: "cita_confirmada_crm_1_trial",
    para: "beuty-nails-viviana-herrera-be-6ac16a · primera cita de la clienta",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n✂️ *Servicio:* {{5}}\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos.\n\n📍 *Dirección:* Plaza Generalife 4, local 7 (barrio Santa Aurelia), 41006 Sevilla\n\n📲 *Para tus próximas citas, escríbenos directamente a este número.*" },
  },
  cita_confirmada_viviana_ficha_trial: {
    base: "cita_confirmada_crm_ficha_trial_v2",
    para: "beuty-nails-viviana-herrera-be-6ac16a · clienta con 2+ citas futuras (botón «Ver mi ficha»)",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n✂️ *Servicio:* {{5}}\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos.\n\n📍 *Dirección:* Plaza Generalife 4, local 7 (barrio Santa Aurelia), 41006 Sevilla" },
  },
  // Con los botones «Cancelar cita» y «Nueva cita» (15/10/2026, docs/features/confirmacion-cita-con-botones.md): mismo
  // texto que las de arriba, sobre las bases _btn (heredan sus botones). Solo salen si la empresa activa los botones.
  cita_confirmada_harold_btn_trial: {
    base: "cita_confirmada_crm_trial_v3_btn",
    para: "terapeuta-harold-c76b79 · con «Cancelar cita» y «Nueva cita» (normal), 15/10/2026",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n💆 *Servicio:* {{5}}\n📍 *Lugar:* Centro Comercial Family Cash, Lorca\n🅿️ Parking y aseo gratuitos.\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos." },
  },
  cita_confirmada_harold_1_btn_trial: {
    base: "cita_confirmada_crm_1_trial_btn",
    para: "terapeuta-harold-c76b79 · con «Cancelar cita» y «Nueva cita» (primera cita), 15/10/2026",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n💆 *Servicio:* {{5}}\n📍 *Lugar:* Centro Comercial Family Cash, Lorca\n🅿️ Parking y aseo gratuitos.\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos.\n\n📲 *Para tus próximas citas, escríbenos directamente a este número.*" },
  },
  cita_confirmada_harold_ficha_btn_trial: {
    base: "cita_confirmada_crm_ficha_trial_v2_btn",
    para: "terapeuta-harold-c76b79 · con «Cancelar cita» y «Nueva cita» (2+ citas futuras («Ver mi ficha»)), 15/10/2026",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n💆 *Servicio:* {{5}}\n📍 *Lugar:* Centro Comercial Family Cash, Lorca\n🅿️ Parking y aseo gratuitos.\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos." },
  },
  cita_confirmada_viviana_btn_trial: {
    base: "cita_confirmada_crm_trial_v3_btn",
    para: "beuty-nails-viviana-herrera-be-6ac16a · con «Cancelar cita» y «Nueva cita» (normal), 15/10/2026",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n✂️ *Servicio:* {{5}}\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos.\n\n📍 *Dirección:* Plaza Generalife 4, local 7 (barrio Santa Aurelia), 41006 Sevilla" },
  },
  cita_confirmada_viviana_1_btn_trial: {
    base: "cita_confirmada_crm_1_trial_btn",
    para: "beuty-nails-viviana-herrera-be-6ac16a · con «Cancelar cita» y «Nueva cita» (primera cita), 15/10/2026",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n✂️ *Servicio:* {{5}}\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos.\n\n📍 *Dirección:* Plaza Generalife 4, local 7 (barrio Santa Aurelia), 41006 Sevilla\n\n📲 *Para tus próximas citas, escríbenos directamente a este número.*" },
  },
  cita_confirmada_viviana_ficha_btn_trial: {
    base: "cita_confirmada_crm_ficha_trial_v2_btn",
    para: "beuty-nails-viviana-herrera-be-6ac16a · con «Cancelar cita» y «Nueva cita» (2+ citas futuras («Ver mi ficha»)), 15/10/2026",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita ha sido registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n✂️ *Servicio:* {{5}}\n\nSi necesitas cancelar o modificar tu cita, contacta con nosotros. Te esperamos.\n\n📍 *Dirección:* Plaza Generalife 4, local 7 (barrio Santa Aurelia), 41006 Sevilla" },
  },
  // Clínicas dentales (19/10/2026, David: «crea ya algunas de dental por si tuviéramos un primer lead»). GENÉRICAS:
  // valen para cualquier clínica dental del número «Citas ConextCRM»; se asignan por empresa con
  // `citas_plantillas_a_medida.js asignar <empresa> <nombre>`. Paciente, tratamiento y 🦷 en vez de ✂️.
  cita_confirmada_dental_trial: {
    base: "cita_confirmada_crm_trial_v3",
    para: "clínicas dentales · confirmación normal",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita en la clínica ha quedado registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n🦷 *Tratamiento:* {{5}}\n\nSi necesitas cambiarla o anularla, avísanos con tiempo y le damos el hueco a otro paciente. Te esperamos." },
  },
  cita_confirmada_dental_1_trial: {
    base: "cita_confirmada_crm_1_trial",
    para: "clínicas dentales · primera visita del paciente",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita en la clínica ha quedado registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n🦷 *Tratamiento:* {{5}}\n\nSi necesitas cambiarla o anularla, avísanos con tiempo y le damos el hueco a otro paciente. Te esperamos.\n\nSi es tu primera visita, ven 10 minutos antes con tu DNI y, si los tienes, tus informes o radiografías.\n\n📲 *Para tus próximas citas, escríbenos directamente a este número.*" },
  },
  cita_confirmada_dental_ficha_trial: {
    base: "cita_confirmada_crm_ficha_trial_v2",
    para: "clínicas dentales · paciente con 2+ citas futuras (botón «Ver mi ficha»)",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita en la clínica ha quedado registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n🦷 *Tratamiento:* {{5}}\n\nSi necesitas cambiarla o anularla, avísanos con tiempo y le damos el hueco a otro paciente. Te esperamos." },
  },
  cita_confirmada_dental_btn_trial: {
    base: "cita_confirmada_crm_trial_v3_btn",
    para: "clínicas dentales · con «Cancelar cita» y «Nueva cita» (normal)",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita en la clínica ha quedado registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n🦷 *Tratamiento:* {{5}}\n\nSi necesitas cambiarla o anularla, avísanos con tiempo y le damos el hueco a otro paciente. Te esperamos." },
  },
  cita_confirmada_dental_1_btn_trial: {
    base: "cita_confirmada_crm_1_trial_btn",
    para: "clínicas dentales · con «Cancelar cita» y «Nueva cita» (primera visita)",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita en la clínica ha quedado registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n🦷 *Tratamiento:* {{5}}\n\nSi necesitas cambiarla o anularla, avísanos con tiempo y le damos el hueco a otro paciente. Te esperamos.\n\nSi es tu primera visita, ven 10 minutos antes con tu DNI y, si los tienes, tus informes o radiografías.\n\n📲 *Para tus próximas citas, escríbenos directamente a este número.*" },
  },
  cita_confirmada_dental_ficha_btn_trial: {
    base: "cita_confirmada_crm_ficha_trial_v2_btn",
    para: "clínicas dentales · con «Cancelar cita» y «Nueva cita» (2+ citas futuras)",
    es: { body: "📩 *{{1}}* te envía esta confirmación:\n\nHola {{2}} ✅\n\nTu cita en la clínica ha quedado registrada:\n\n📅 *Fecha:* {{3}}\n🕐 *Hora:* {{4}}\n🦷 *Tratamiento:* {{5}}\n\nSi necesitas cambiarla o anularla, avísanos con tiempo y le damos el hueco a otro paciente. Te esperamos." },
  },
  // ── AUTOESCUELAS ──
  // Autoescuela Poveda (28/10/2026, WhatsApp de Rosana): el aviso de la práctica 2 días antes a las 10:30
  // (docs/features/autoescuela-avisos-programados.md) con SU texto («*AUTOESCUELA POVEDA* / X día a las x horas / X clases
  // prácticas / Ok? / su norma»). La hora ({{4}}) ya lleva el fin, las clases y el profesor (datos_practica de Poveda).
  practica_aviso_poveda_trial: {
    base: "practica_aviso_confirmar_crm_trial",
    para: "autoescuela-poveda-36e1d8 · Rosana 28/10/2026 (aviso 2 días antes con su norma)",
    es: { body: "📩 *{{1}}*\n\nHola {{2}}, tienes práctica el {{3}} a las {{4}}.\n\nOk? Confírmala con el botón.\n\nUNA VEZ CONFIRMADA LA CLASE PRÁCTICA NO PUEDE SER ANULADA Y SERÁ PENALIZADO CON EL PAGO DE LA MISMA.\nRECUERDA QUE TIENE QUE ESTAR PAGADA LA CLASE PRÁCTICA ANTES DE SU REALIZACIÓN." },
  },
  // v2 (29/10/2026, Rosana: «Queremos quitar lo de Ok? Y ponerles el botón de cancelar para los que no quieran la
  // práctica»): sin «Ok?» y con «Cancelar práctica». Base = el aviso con los dos botones (avisos_programados.aviso.boton_cancelar).
  practica_aviso_poveda_v2_trial: {
    base: "practica_aviso_confirmar_cancelar_crm_trial",
    para: "autoescuela-poveda-36e1d8 · Rosana 29/10/2026 (sin «Ok?», con «Cancelar práctica»)",
    es: { body: "📩 *{{1}}*\n\nHola {{2}}, tienes práctica el {{3}} a las {{4}}.\n\nConfírmala con el botón. Si no puedes venir, pulsa «Cancelar práctica».\n\nUNA VEZ CONFIRMADA LA CLASE PRÁCTICA NO PUEDE SER ANULADA Y SERÁ PENALIZADO CON EL PAGO DE LA MISMA.\nRECUERDA QUE TIENE QUE ESTAR PAGADA LA CLASE PRÁCTICA ANTES DE SU REALIZACIÓN." },
  },
  // Recordatorio de la víspera (15:00) con SU texto (4/11/2026, Poveda por WhatsApp: «Queríamos hacer un cambio en el
  // mensaje del recordatorio. Que sea así»). Sin la cabecera «RECORDATORIO DE PRÁCTICA»: abre con su «🚗 AUTOESCUELA
  // POVEDA». La hora ({{4}}) ya lleva el fin, las clases y el profesor (datos_practica), que es su «X clases a las X
  // horas». Por su número dedicado sale la gemela _ded (sin la línea del {{1}}). _conf = sin confirmar (botón).
  practica_recordatorio_poveda_conf_trial: {
    base: "practica_recordatorio_crm_trial_conf",
    para: "autoescuela-poveda-36e1d8 · 4/11/2026 (recordatorio de la víspera con su texto, sin confirmar)",
    es: {
      header: "",
      body: "📩 *{{1}}*\n\n🚗 *AUTOESCUELA POVEDA*\n\nHola {{2}}! Te recordamos que el día {{3}} tienes programada tu clase práctica de conducción, a las {{4}}.\n\nConfirma tu asistencia con el botón.\n\n⚠️ *IMPORTANTE*: En caso de no asistir o solicitar su cancelación, será obligatorio abonar el importe correspondiente a la clase.\n\nSi tienes cualquier problema o necesitas comunicárnoslo, puedes contactar con nosotros a través del WhatsApp habitual:\n\n📲 640 683 056\n\nGracias por tu colaboración!",
      footer: "AUTOESCUELA POVEDA",
    },
  },
  practica_recordatorio_poveda_sinbtn_trial: {
    base: "practica_recordatorio_crm_trial_sinbtn",
    para: "autoescuela-poveda-36e1d8 · 4/11/2026 (recordatorio de la víspera con su texto, ya confirmada)",
    es: {
      header: "",
      body: "📩 *{{1}}*\n\n🚗 *AUTOESCUELA POVEDA*\n\nHola {{2}}! Te recordamos que el día {{3}} tienes programada tu clase práctica de conducción, a las {{4}}.\n\n⚠️ *IMPORTANTE*: En caso de no asistir o solicitar su cancelación, será obligatorio abonar el importe correspondiente a la clase.\n\nSi tienes cualquier problema o necesitas comunicárnoslo, puedes contactar con nosotros a través del WhatsApp habitual:\n\n📲 640 683 056\n\nGracias por tu colaboración!",
      footer: "AUTOESCUELA POVEDA",
    },
  },
  // Autoescuela Carian (3/11/2026, Anna: «que el mensaje indicara "Estas son tus próximas prácticas" en lugar de "Estas son
  // las prácticas de esta semana"; normalmente enviamos los horarios con antelación»). TODAS las variantes del resumen
  // semanal que puede mandar: una línea por práctica (1..7), y la de siempre con/sin botones y con/sin imagen (más de 7
  // prácticas o la casilla de botones desmarcada). Genéricas: valen para cualquier autoescuela que envíe con antelación.
  practicas_proximas_1_trial: {
    base: "practicas_semana_1_crm_trial",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», 1 línea)",
    es: { body: "📩 *{{1}}* te informa:\n\nPráctica programada ✅\n\nHola {{2}}, esta es tu próxima práctica:\n\n• {{3}}\n\nSi te viene bien, pulsa «Me viene bien». Si ese día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_2_trial: {
    base: "practicas_semana_2_crm_trial",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», 2 líneas)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_3_trial: {
    base: "practicas_semana_3_crm_trial",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», 3 líneas)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_4_trial: {
    base: "practicas_semana_4_crm_trial",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», 4 líneas)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_5_trial: {
    base: "practicas_semana_5_crm_trial",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», 5 líneas)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_6_trial: {
    base: "practicas_semana_6_crm_trial",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», 6 líneas)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_7_trial: {
    base: "practicas_semana_7_crm_trial",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», 7 líneas)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n• {{9}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  // Las mismas con la imagen de la semana en la cabecera (3/11/2026, David: «la semanal debería llevar imagen»). Mismo texto
  // que las de arriba; su base es la `_img` (HEADER IMAGE heredado).
  practicas_proximas_1_img_trial: {
    base: "practicas_semana_1_crm_trial_img",
    para: "autoescuela-carian-866a3f · 3/11/2026 («tus próximas prácticas», 1 línea, con la imagen de la semana)",
    es: { body: "📩 *{{1}}* te informa:\n\nPráctica programada ✅\n\nHola {{2}}, esta es tu próxima práctica:\n\n• {{3}}\n\nSi te viene bien, pulsa «Me viene bien». Si ese día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_2_img_trial: {
    base: "practicas_semana_2_crm_trial_img",
    para: "autoescuela-carian-866a3f · 3/11/2026 («tus próximas prácticas», 2 líneas, con la imagen de la semana)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_3_img_trial: {
    base: "practicas_semana_3_crm_trial_img",
    para: "autoescuela-carian-866a3f · 3/11/2026 («tus próximas prácticas», 3 líneas, con la imagen de la semana)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_4_img_trial: {
    base: "practicas_semana_4_crm_trial_img",
    para: "autoescuela-carian-866a3f · 3/11/2026 («tus próximas prácticas», 4 líneas, con la imagen de la semana)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_5_img_trial: {
    base: "practicas_semana_5_crm_trial_img",
    para: "autoescuela-carian-866a3f · 3/11/2026 («tus próximas prácticas», 5 líneas, con la imagen de la semana)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_6_img_trial: {
    base: "practicas_semana_6_crm_trial_img",
    para: "autoescuela-carian-866a3f · 3/11/2026 («tus próximas prácticas», 6 líneas, con la imagen de la semana)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_7_img_trial: {
    base: "practicas_semana_7_crm_trial_img",
    para: "autoescuela-carian-866a3f · 3/11/2026 («tus próximas prácticas», 7 líneas, con la imagen de la semana)",
    es: { body: "📩 *{{1}}* te informa:\n\nPrácticas programadas ✅\n\nHola {{2}}, estas son tus próximas prácticas:\n\n• {{3}}\n• {{4}}\n• {{5}}\n• {{6}}\n• {{7}}\n• {{8}}\n• {{9}}\n\nSi te vienen bien, pulsa «Me viene bien». Si algún día no puedes venir, pulsa «Quiero cambiar algo» y la autoescuela lo revisará contigo." },
  },
  practicas_proximas_trial: {
    base: "practicas_semana_crm_trial",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», sin botones)",
    es: { body: "📩 *{{1}}* te informa:\n\nHola {{2}} 👋\n\nEstas son tus próximas prácticas programadas:\n\n{{3}}\n\nPara cualquier cambio o cancelación, contáctanos por este chat." },
  },
  practicas_proximas_img_trial: {
    base: "practicas_semana_crm_trial_img",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», sin botones, con imagen)",
    es: { body: "📩 *{{1}}* te informa:\n\nHola {{2}} 👋\n\nEstas son tus próximas prácticas programadas:\n\n{{3}}\n\nPara cualquier cambio o cancelación, contáctanos por este chat." },
  },
  practicas_proximas_btn_trial: {
    base: "practicas_semana_crm_trial_btn",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», con botones, más de 7)",
    es: { body: "📩 *{{1}}* te informa:\n\nHola {{2}} 👋\n\nEstas son tus próximas prácticas programadas:\n\n{{3}}\n\nPara cualquier cambio o cancelación, contáctanos por este chat." },
  },
  practicas_proximas_img_btn_trial: {
    base: "practicas_semana_crm_trial_img_btn",
    para: "autoescuela-carian-866a3f · Anna 3/11/2026 («tus próximas prácticas», con botones e imagen, más de 7)",
    es: { body: "📩 *{{1}}* te informa:\n\nHola {{2}} 👋\n\nEstas son tus próximas prácticas programadas:\n\n{{3}}\n\nPara cualquier cambio o cancelación, contáctanos por este chat." },
  },
  recordatorio_dental_trial: {
    base: "recordatoriop1_trial",
    para: "clínicas dentales · recordatorio con Confirmar/Cancelar",
    es: { header: "RECORDATORIO DE TU CITA", body: "📩 *{{1}}* te envía este recordatorio:\n\nHola {{2}},\n\nTe recordamos tu cita en la clínica el {{3}} a las {{4}}.\n\nNos confirmas si vienes? Si no puedes, anúlala aquí y le damos el hueco a otro paciente." },
  },
});

const MAX_A_MEDIDA = 40;
const NOMBRE_PLANTILLA = /^[a-z0-9_]{1,512}$/;

/** La mayor n de las variables {{n}} de un texto (0 si no tiene). PURA. */
function numVariables(texto) {
  let max = 0;
  String(texto || "").replace(/\{\{(\d+)\}\}/g, (_, n) => { max = Math.max(max, Number(n)); return ""; });
  return max;
}

/**
 * El mapa { base: a medida } de una empresa, saneado: solo entradas que existen en el registro y que sustituyen
 * EXACTAMENTE a esa base. Se escribe a mano: un typo no puede romper ni el envío ni la página. PURA.
 */
function sanearPlantillasAMedida(raw, registro = PLANTILLAS_A_MEDIDA) {
  const out = {};
  if (!raw || typeof raw !== "object" || Array.isArray(raw) || raw instanceof Set) return out;
  for (const [base, nombre] of Object.entries(raw)) {
    if (Object.keys(out).length >= MAX_A_MEDIDA) break;
    if (typeof nombre !== "string" || !NOMBRE_PLANTILLA.test(base) || !NOMBRE_PLANTILLA.test(nombre)) continue;
    const def = registro[nombre];
    if (!def || def.base !== base || !def.es || typeof def.es.body !== "string") continue;
    out[base] = nombre;
  }
  return out;
}

/**
 * La plantilla a medida que sale en lugar de `nombre` (la _trial estándar) para la empresa con ese mapa, o null.
 * En catalán solo si la a medida tiene `ca` (si no, manda el idioma: sale la estándar en catalán). PURA.
 */
function elegirAMedida(mapa, nombre, idioma = "es", registro = PLANTILLAS_A_MEDIDA) {
  const a = sanearPlantillasAMedida(mapa, registro)[nombre];
  if (!a) return null;
  if (idioma === "ca" && !registro[a].ca) return null;
  return a;
}

/** Los textos de una a medida en ese idioma (o null). PURA. */
function definicionAMedida(nombre, idioma = "es", registro = PLANTILLAS_A_MEDIDA) {
  const d = registro[nombre];
  if (!d) return null;
  return (idioma === "ca" && d.ca) || d.es || null;
}

const up = (s) => String(s || "").toUpperCase();

/**
 * Componentes de Meta de una a medida a partir de los de su BASE (SYSTEM_TEMPLATES): misma estructura (cabecera,
 * variables, botones y su tipo/orden, URL dinámica, ejemplos); solo cambian los TEXTOS. PURA.
 */
function componentesAMedida(baseComponents, textos) {
  const t = textos || {};
  const out = [];
  let tieneFooter = false;
  for (const c of baseComponents || []) {
    const tipo = up(c && c.type);
    if (tipo === "HEADER" && up(c.format) === "TEXT") {
      if (t.header === "") continue;
      out.push(t.header !== undefined ? { ...c, text: t.header } : c);
    } else if (tipo === "BODY") {
      out.push({ ...c, text: t.body !== undefined ? t.body : c.text });
      if (t.footer && !(baseComponents || []).some((x) => up(x && x.type) === "FOOTER")) {
        out.push({ type: "FOOTER", text: t.footer });
        tieneFooter = true;
      }
    } else if (tipo === "FOOTER") {
      if (t.footer === "" || tieneFooter) continue;
      out.push(t.footer !== undefined ? { ...c, text: t.footer } : c);
    } else if (tipo === "BUTTONS") {
      let qr = 0;
      out.push({
        ...c,
        buttons: (c.buttons || []).map((b) => {
          const bt = up(b && b.type);
          if (bt === "QUICK_REPLY") {
            const txt = Array.isArray(t.botones) ? t.botones[qr] : undefined;
            qr += 1;
            return txt ? { ...b, text: txt } : b;
          }
          if ((bt === "URL" || bt === "FLOW") && t.cta) return { ...b, text: t.cta };
          return b;
        }),
      });
    } else {
      out.push(c);
    }
  }
  return out;
}

/** La plantilla (forma de SYSTEM_TEMPLATES) de una a medida en castellano, dada su base. PURA. */
function plantillaMetaAMedida(nombre, baseTemplate, registro = PLANTILLAS_A_MEDIDA, idioma = "es") {
  const def = registro[nombre];
  if (!def || !baseTemplate) return null;
  const textos = idioma === "ca" ? def.ca : def.es;
  if (!textos) return null;
  return {
    name: nombre,
    language: idioma,
    category: baseTemplate.category || "UTILITY",
    components: componentesAMedida(baseTemplate.components, textos),
  };
}

/**
 * Las entradas de SYSTEM_TEMPLATES de todas las a medida cuya base existe en `systemTemplates`. Nunca pisa una
 * plantilla que ya esté (una a medida no puede llamarse como una estándar). PURA.
 */
function systemTemplatesAMedida(systemTemplates, registro = PLANTILLAS_A_MEDIDA) {
  const out = {};
  for (const nombre of Object.keys(registro)) {
    const base = systemTemplates && systemTemplates[registro[nombre].base];
    if (!base || (systemTemplates && systemTemplates[nombre])) continue;
    const t = plantillaMetaAMedida(nombre, base, registro);
    if (t) out[nombre] = t;
  }
  return out;
}

/** Nombres de las a medida con traducción catalana (para la lista de `ca` de c_sendTemplate). PURA. */
function nombresCaAMedida(registro = PLANTILLAS_A_MEDIDA) {
  return Object.keys(registro).filter((n) => registro[n] && registro[n].ca);
}

const quickReplies = (components) => {
  const b = (components || []).find((c) => up(c && c.type) === "BUTTONS");
  return ((b && b.buttons) || []).filter((x) => up(x && x.type) === "QUICK_REPLY").map((x) => x.text);
};
const cuerpoDe = (components) => ((components || []).find((c) => up(c && c.type) === "BODY") || {}).text || "";
const EMOJI = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/u;

/**
 * Lo que está mal en una a medida frente a su base (lista vacía = bien). Lo usan el test y el script de alta. PURA.
 * @param baseTemplate la base en forma de SYSTEM_TEMPLATES (castellano)
 */
function erroresAMedida(nombre, baseTemplate, registro = PLANTILLAS_A_MEDIDA) {
  const e = [];
  const def = registro[nombre];
  if (!NOMBRE_PLANTILLA.test(nombre)) e.push(`${nombre}: nombre no válido para Meta (minúsculas, cifras y _)`);
  if (!def) return [...e, `${nombre}: no está en el registro`];
  if (!baseTemplate) return [...e, `${nombre}: la base ${def.base} no existe en SYSTEM_TEMPLATES`];
  if (nombre === def.base) e.push(`${nombre}: no puede llamarse igual que su base`);
  const nBase = numVariables(cuerpoDe(baseTemplate.components));
  const qrBase = quickReplies(baseTemplate.components);
  for (const lang of ["es", "ca"]) {
    const t = def[lang];
    if (!t) { if (lang === "es") e.push(`${nombre}: falta el texto en castellano (es)`); continue; }
    if (typeof t.body !== "string" || !t.body.trim()) { e.push(`${nombre} [${lang}]: falta el cuerpo`); continue; }
    const n = numVariables(t.body);
    if (n !== nBase) e.push(`${nombre} [${lang}]: usa hasta {{${n}}} y la base usa hasta {{${nBase}}} (mismas variables)`);
    for (let i = 1; i <= nBase; i += 1) if (!t.body.includes(`{{${i}}}`)) e.push(`${nombre} [${lang}]: falta {{${i}}}`);
    if (/\{\{\d+\}\}\s*$/.test(t.body)) e.push(`${nombre} [${lang}]: Meta no admite acabar en una variable`);
    if (/(^|\n)\s*[¿¡]/.test(t.body)) e.push(`${nombre} [${lang}]: sin «¿»/«¡» de apertura`);
    const qr = quickReplies(componentesAMedida(baseTemplate.components, t));
    if (qr.length !== qrBase.length) e.push(`${nombre} [${lang}]: botones distintos de la base`);
    if (Array.isArray(t.botones) && t.botones.length !== qrBase.length) e.push(`${nombre} [${lang}]: ${t.botones.length} botones y la base tiene ${qrBase.length}`);
    for (const b of qr) {
      if (EMOJI.test(b)) e.push(`${nombre} [${lang}]: el botón «${b}» lleva emoji (Meta lo rechaza)`);
      if (b.length > 25) e.push(`${nombre} [${lang}]: el botón «${b}» pasa de 25 caracteres`);
    }
  }
  return e;
}
// ── plantillasAMedida: cuerpo compartido (fin) ──

export {
  PLANTILLAS_A_MEDIDA, MAX_A_MEDIDA, numVariables, sanearPlantillasAMedida, elegirAMedida, definicionAMedida,
  componentesAMedida, plantillaMetaAMedida, systemTemplatesAMedida, nombresCaAMedida, erroresAMedida,
};
